import React, { useRef, useState, useEffect, useContext } from "react";
import { BiSend } from "react-icons/bi";
import {
  AiFillLike,
  AiOutlineLike,
  AiFillDislike,
  AiOutlineDislike,
} from "react-icons/ai";
import Scrollbutton from "../Scrollbutton/Scrollbutton";
import { FiExternalLink } from "react-icons/fi";
import "./Chatwindow.css";
import TypingIndicator from "../TypingIndicator/TypingIndicator";
import botLogo from "../../assets/bot-icon.png";
// import ErrorCard from "../Cards/ErrorCard";
import userLogo from "../../assets/user-icon3.png";
import { useAuth } from "react-oidc-context";
import { GlobalStateContext } from "../../GlobalStateProvider";

const Chatwindow = () => {
  const [chatMessages, setChatMessages] = useState([]);
  const [userMessage, setUserMessages] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesRef = useRef(null);
  const [textValue, setTextValue] = useState("");
  const [newMessage, setNewMessage] = useState(null);
  const { index, indexType } = useContext(GlobalStateContext);
  const [history, setHistory] = useState([]);
  const [error, setError] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);
  const auth = useAuth();
  const profile = auth.user?.profile;
  const backend_url = indexType === 'excel'? process.env.REACT_APP_EXCEL_URL : process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const messagesDiv = messagesRef.current;
    function handleScroll() {
      if (
        messagesDiv.scrollTop <
        messagesDiv.scrollHeight - messagesDiv.clientHeight - 50
      ) {
        setIsScrollable(true);
      } else {
        setIsScrollable(false);
      }
    }

    messagesDiv.addEventListener("scroll", handleScroll);

    return () => {
      messagesDiv.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // auto scroll to bottom on new message
  useEffect(() => {
    scrollToBottom();
  }, [newMessage]);

  // Retrieve chat messages and history from local storage
  useEffect(() => {
    setChatMessages([]);
    setHistory([]);
    const storedChatMessages = JSON.parse(
      localStorage.getItem(`chat-${index}`)
    );
    const storedChatHistory = JSON.parse(
      localStorage.getItem(`history-${index}`)
    );
    if (storedChatMessages !== null) {
      setChatMessages(storedChatMessages);
    }
    if (storedChatHistory !== null) {
      setHistory(storedChatHistory);
    }
    if (!storedChatMessages) {
      const newBotMessage = {
        content: "Hello! How can I help you?",
        sender: "bot",
        timestamp: findTime(),
        source: "",
      };
      setChatMessages((prevMessages) => [...prevMessages, newBotMessage]);
    }
  }, [index]);

  /*UTILITY FUNCTIONS*/

  // This function keeps the recent n pairs of messages in the history
  const limitHistory = (n) => {
    const length = history.length;
    if (length > n) {
      history.splice(0, length - n);
    }
  };

  // This function clears chat and data stored in localstorage
  const clearChat = () => {
    setLoading(false);
    setError(false);
    setChatMessages([]);
    setHistory([]);
    localStorage.setItem(`history-${index}`, JSON.stringify([]));
    localStorage.setItem(`chat-${index}`, JSON.stringify([]));
  };

  // This function scrolls to the bottom of the message div
  const scrollToBottom = () => {
    if (messagesRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }
  };

  // Function to extract the first completeurl from the source string of the format "[domain](completeurl)..."
  const extractFirstUrl = (urlString) => {
    const regex = /\[(.*?)\]\((.*?)\)/g;
    const match = regex.exec(urlString);
    if (match) {
      return match[2];
    }
  };

  // Utility function to check whether to disable the send button
  const checkDisabled = () => {
    if (textValue === "" || loading) return true;
    else return false;
  };
  const checkDisabledInput = () => {
    if (loading) return true;
  };

  // Function to get current time in 24 hrs format
  const findTime = () => {
    const d = new Date(),
      h = (d.getHours() < 10 ? "0" : "") + d.getHours(),
      m = (d.getMinutes() < 10 ? "0" : "") + d.getMinutes();
    return h + ":" + m;
  };

  // Handle like and dislike
  const handleLike = (i, feedback) => {
    setChatMessages((prevChatmessages) => {
      const updatedChatmessages = [...prevChatmessages];
      updatedChatmessages[i].feedback = true;
      localStorage.setItem(
        `chat-${index}`,
        JSON.stringify(updatedChatmessages)
      );

      fetch(backend_url + "/api/ApiChatHistoryUpdate", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify({
          index: index,
          msid: profile.sub,
          conversationid: updatedChatmessages[i].conversationid,
          feedback: updatedChatmessages[i].feedback,
          chatid: updatedChatmessages[i].chatid,
        }),
      })
        .then((res) => {
          try {
            return res.json();
          } catch (error) {
            console.log("error: ", error);
          }
        })
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          console.log("error", error);
        });

      return updatedChatmessages;
    });
  };
  const handleDislike = (i) => {
    setChatMessages((prevChatmessages) => {
      const updatedChatmessages = [...prevChatmessages];
      updatedChatmessages[i].feedback = false;
      localStorage.setItem(
        `chat-${index}`,
        JSON.stringify(updatedChatmessages)
      );

      fetch(backend_url + "/api/ApiChatHistoryUpdate", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify({
          index: index,
          msid: profile.sub,
          conversationid: updatedChatmessages[i].conversationid,
          feedback: updatedChatmessages[i].feedback,
          chatid: updatedChatmessages[i].chatid,
        }),
      })
        .then((res) => {
          try {
            return res.json();
          } catch (error) {
            console.log("error: ", error);
          }
        })
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          console.log("error", error);
        });
      return updatedChatmessages;
    });
  };

  // This function handles the outgoing and incoming messages.
  const handleUserInput = async () => {
    setError(false);
    limitHistory(20);
    setTextValue("");
    const historyTuple = [];
    const updatedMessage = [];
    const tempHistory = history;
    if (userMessage.trim() !== "") {
      const newUserMessage = {
        content: userMessage,
        sender: "user",
        timestamp: findTime(),
      };
      setNewMessage(newUserMessage);
      setChatMessages((prevMessages) => [...prevMessages, newUserMessage]);
      updatedMessage.push(...chatMessages, newUserMessage);
      historyTuple.push(newUserMessage.content);
    }
    setLoading("true");

    let reqbody = {};
    if (indexType == "excel") {
      reqbody = {
        msid: profile.sub,
        question: userMessage,
        index: index,
      };
    }
    else{
      reqbody = {
        msid: profile.sub,
        question: userMessage,
        history: history,
        index: index,
      };
    }

    // fetch("https://uni-ai-bot.optum.com/api/ApiQnA", {
    fetch(backend_url + "/api/ApiQnA", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(reqbody),
    })
      .then((response) => {
        setLoading(false);
        setUserMessages("");
        // console.log(response.json());
        try {
          return response.json();
        } catch (error) {
          console.log("error: ", error);
          // console.error(error);
        }
      })
      .then((botResponse) => {
        // console.log("botResponse", botResponse);
        const urlString = botResponse.sources;
        const source1 = extractFirstUrl(urlString);
        const str = botResponse.response.substring(
          0,
          botResponse.response.length - 1
        );
        historyTuple.push(str);
        const newBotMessage = {
          content: str,
          sender: "bot",
          timestamp: findTime(),
          feedback: null,
          source: source1,
          chatid: botResponse.chatid,
          conversationid: botResponse.conversationid,
        };
        setNewMessage(newBotMessage);
        setHistory((prevHistory) => [...prevHistory, historyTuple]);
        setChatMessages((prevMessages) => [...prevMessages, newBotMessage]);
        updatedMessage.push(newBotMessage);
        tempHistory.push(historyTuple);
        localStorage.setItem(`chat-${index}`, JSON.stringify(updatedMessage));
        localStorage.setItem(`history-${index}`, JSON.stringify(tempHistory));
      })
      .catch((error) => {
        console.error(error);
        setError(true);
        setUserMessages("");
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="chat-window">
        <div className="heading">
          <p>Chat</p>
          {/* <button onClick={doFetch} className="btn clear">
            Perform Fetch
          </button> */}
          {error ? (
            <span className="heads-up error-message">
              We are facing heavy traffic. Please clear chat and try again
            </span>
          ) : (
            <span className="heads-up">Connected to {index} bot</span>
          )}
          <button onClick={clearChat} className="btn clear">
            Clear Chat
          </button>
        </div>

        <div className="Message" ref={messagesRef}>
          {chatMessages.map((message, kindex) => (
            <div
              key={kindex}
              className={`chat-message ${
                message.sender === "bot" ? "bot-message" : "user-message"
              }`}
            >
              <span className={`${message.sender === "bot" ? "bot" : "user"}`}>
                {message.sender === "bot" ? (
                  <img src={botLogo} alt="botlogo" className="avatar" />
                ) : (
                  <img src={userLogo} alt="userlogo" className="avatar" />
                )}
                <pre
                  className={`${
                    message.sender === "bot" ? "bot-content" : "user-content"
                  }`}
                >
                  {message.content}
                  {!error && message.source && (
                    <div className="source">
                      <a href={message.source} rel="noreferrer" target="_blank">
                        Link to Source
                        <FiExternalLink />
                      </a>
                    </div>
                  )}
                </pre>
              </span>
              <div className="message-metadata">
                {message.sender === "bot" && (
                  <span className={`feedback`}>
                    {/* {console.log("feedback: ", message.feedback)} */}
                    <button
                      className="likebtn"
                      onClick={() => {
                        handleLike(kindex);
                      }}
                      title="like"
                    >
                      {message.feedback === true ? (
                        <AiFillLike className="likeicon like-active" />
                      ) : (
                        <AiOutlineLike className="likeicon" />
                      )}
                    </button>
                    <button
                      className="dislikebtn"
                      onClick={() => {
                        handleDislike(kindex);
                      }}
                      title="dislike  "
                    >
                      {message.feedback === false ? (
                        <AiFillDislike className="dislikeicon dislike-active" />
                      ) : (
                        <AiOutlineDislike className="dislikeicon" />
                      )}
                    </button>
                  </span>
                )}
                <span
                  className={`timestamp ${
                    message.sender === "user" ? "user-timestamp " : ""
                  }`}
                >
                  {message.timestamp}
                </span>
              </div>
            </div>
          ))}
          {loading && (
            <div style={{ display: "flex" }}>
              <img src={botLogo} alt="bot logo" className="avatar" />
              <TypingIndicator />
            </div>
          )}
          {isScrollable && (
            <div className="chatScroller">
              <Scrollbutton onClick={scrollToBottom} />
            </div>
          )}
        </div>

        <div className="input-box">
          <input
            type="text"
            name="message-box"
            value={textValue}
            onChange={(e) => {
              setTextValue(e.target.value);
              setUserMessages(e.target.value);
            }}
            placeholder="Type your message"
            className="messagebox"
            disabled={checkDisabledInput()}
            onKeyDown={(e) => {
              if (e.key === "Enter" && textValue !== "" && !loading) {
                handleUserInput();
              }
            }}
          />
          <button
            onClick={handleUserInput}
            className="btn"
            disabled={checkDisabled()}
          >
            <BiSend size={25} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Chatwindow;
